import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  lastModified: '',
  lastRequestTime: null,
  platformOverviewState: {
    isFetching: false,
    isFetched: false,
    isFailed: false,
    item: null,
    errorMessage: '',
  },
}

export const platformOverviewSlice = createSlice({
  name: 'platformOverview',
  initialState: initialState,
  reducers: {
    getPlatformOverviewRequest: (state: any) => {
      state.platformOverviewState.isFetching = true
      state.platformOverviewState.isFetched = false
      state.platformOverviewState.isFailed = false
      state.platformOverviewState.errorMessage = ''
    },
    getPlatformOverviewSuccess: (state: any, action) => {
      state.platformOverviewState.isFetching = false
      state.platformOverviewState.isFetched = true
      state.platformOverviewState.item = action.payload.item
    },
    getPlatformOverviewFailure: (state: any, action) => {
      state.platformOverviewState.isFetching = false
      state.platformOverviewState.isFetched = true
      state.platformOverviewState.isFailed = true
      state.platformOverviewState.errorMessage = action.payload.errorMessage
    },
  },
})

export const {
  getPlatformOverviewRequest,
  getPlatformOverviewSuccess,
  getPlatformOverviewFailure,
} = platformOverviewSlice.actions

export default platformOverviewSlice.reducer
